export const Permissions = { // Note that FullAccess properties don't need to be added because those permissions cascade up using the hasPermission function
    Clients: {
        General: {
            Read: "Client.General.Read",
            Edit: "Client.General.Edit"
        },
        Comments: {
            Read: "Client.Comments.Read",
            Edit: "Client.Comments.Edit"
        },
        Policies: {
            Read: "Client.Policies.Read",
            Edit: "Client.Policies.Edit"
        },
        Contracts: {
            Read: "Client.Contracts.Read",
            Edit: "Client.Contracts.Edit"
        },
        Custom: {
            Read: "Client.Custom.Read",
            Edit: "Client.Custom.Edit"
        },
        Payroll: {
            Read: "Client.Payroll.Read",
            Edit: "Client.Payroll.Edit"
        },
    },
    File: {
        Import: "File.Import",
        Comments: {
            Read: "File.Comments.Read",
            Edit: "File.Comments.Edit"
        },
        Exceptions: {
            Read: "File.Exceptions.Read",
            Edit: "File.Exceptions.Edit"
        },
        CustomFields: {
            Read: "File.CustomFields.Read",
            Edit: "File.CustomFields.Edit"
        },
        STA: {
            Read: "File.STA.Read",
            Edit: "File.STA.Edit"
        },
        Intake: {
            Read: "File.Intake.Read",
            Edit: "File.Intake.Edit",
            Submit: "File.Intake.Submit",
            Approve: "File.Intake.Approve", // TODO: not yet enforced in UI
            Cancel: "File.Intake.Cancel"
        },
        Pending: {
            Read: "File.Pending.Read",
            Edit: "File.Pending.Edit",
            Submit: "File.Pending.Submit",
            Approve: "File.Pending.Approve",
            Import: "File.Pending.Import"
        },
        TempLiving: {
            Read: "File.TempLiving.Read",
            Edit: "File.TempLiving.Edit"
        },
        HHG: {
            Read: "File.HHG.Read",
            Edit: "File.HHG.Edit"
        },
        Destination: {
            Read: "File.Dest.Read",
            Edit: "File.Dest.Edit"
        },
        Homesale: {
            Read: "File.HS.Read",
            Edit: "File.HS.Edit",
            Equity: {
                Post: "File.HS.Equity.Post",
                PostDetail: "File.HS.Equity.PostDetail"
            },
            Title: {
                Edit: "File.HS.Title.Edit"
            }
        },
        Global: {
            Read: "File.Global.Read",
            Edit: "File.Global.Edit"
        },
        CandidateIntern: {
            Read: "File.CandIntern.Read",
            Edit: "File.CandIntern.Edit"
        }
    },
    Finance: {
        Expenses: {
            Read: "Finance.Expenses.Read",
            Edit: "Finance.Expenses.Edit",
            Submit: "Finance.Expenses.Submit", // TODO: not yet enforced in UI
            Approve: "Finance.Expenses.Approve"
        },
        Vouchers: {
            Read: "Finance.Vouchers.Read",
            Edit: "Finance.Vouchers.Edit",
            Submit: "Finance.Vouchers.Submit",
            Approve: "Finance.Vouchers.Approve",
            Import: "Finance.Vouchers.Import",
            PayrollDate: "Finance.Vouchers.PayrollDate.Edit"
        },
        RecurringPayables: {
            Read: "Finance.RPs.Read",
            Edit: "Finance.RPs.Edit",
            Submit: "Finance.RPs.Submit",
            Approve: "Finance.RPs.Approve",
            Import: "Finance.RPs.Import" // TODO: not yet enforced in UI
        },
        Fees: {
            Read: "Finance.Fees.Read",
            Edit: "Finance.Fees.Edit",
            Submit: "Finance.Fees.Submit", // TODO: not yet enforced in UI
            Approve: "Finance.Fees.Approve"
        }
    },
    Vendor: {
        All: {
            Read: "Vendor.Read",
            Edit: "Vendor.Edit"
        }
    },
    Admin: {
        Surveys: {
            Read: "Admin.Surveys.Read",
            Edit: "Admin.Surveys.Edit"
        },
        Tasks: {
            Read: "Admin.Tasks.Read",
            Edit: "Admin.Tasks.Edit"
        },
        Templates: {
            Read: "Admin.Templates.Read",
            Edit: "Admin.Templates.Edit"
        },
        DataMgmt: {
            Read: "Admin.DataMgmt.Read",
            Edit: "Admin.DataMgmt.Edit"
        },
        ICU: {
            Read: "Admin.ICU.Read",
            Edit: "Admin.ICU.Edit"
        }
    }
};

// Entra token permissions are decoded -> set as 'UserPermissions' in local storage -> user clicks on a route
// -> module permissions are passed to that component (contains an object of booleans populated by checking the Entra token permissions against the global permissions)